import emptyCadastroBase from './emptyCadastroBase'

export default {
  ...emptyCadastroBase,
  tipo: {
    codigo: 'INFORMACOES'
  },
  json: {
    informacaoDesejada: {
      tipoInformacao: null,
      descricaoOutro: null,
      justificativa: null
    },
    cadastrante: {
      pessoa: {
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null,
          telefones: [],
          email: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null,
          telefones: [],
          email: null
        },
        telefones: []
      }
    },
    interessado: {
      pessoa: {
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null,
          telefones: [],
          email: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null,
          telefones: [],
          email: null
        },
        telefones: []
      },
      documentos: [],
      espolio: null
    },
    imovel: {
      id: null,
      documentos: [],
      denominacao: null,
      area: 0,
      nomeColonia: null,
      localizacao: null,
      municipio: {
        id: null,
        nome: null,
        codigoEstado: null
      },
      // matricula
      cnsMatricula: null,
      numeroMatricula: null,
      livroMatricula: null,
      numeroFolhaMatricula: null,
      // dados do titulo
      nomeBeneficiarioTitulo: null,
      numeroTitulo: null,
      areaTitulo: 0,
      dataExpedicaoTitulo: null,
      numeroLote: null,
      municipioTitulo: {
        id: null,
        nome: null,
        codigoEstado: null
      }
    },
    georreferenciamento: {
      localizacoes: [],
      documentos: [],
      possuiGeorreferenciamento: 'NAO_POSSUI'
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/central/cadastros/para/empty/emptySolicitacaoInformacao.js